import React, { useState } from "react";

//components material mui
import {
    Button,
    DialogContent,
    DialogActions,
    Typography,
    Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";

//components
import { DialogoBoostrap } from "../../ControlUsuario/DialogoPersonalizado/DialogoBoostrap";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

let funcionAbrirModal;
let validaAbrirModal;

/**
 * Modal "¡Tu pago fue un éxito!" (image 4).
 *
 * @param {{ onContinuar:function }} param0
 */
export const DialogoPagoExitoso = ({ onContinuar = () => {} }) => {
    const { etiquetas } = useGlobalState();

    const [abierto, setAbierto] = useState(false);
    funcionAbrirModal = setAbierto;
    validaAbrirModal = abierto;

    const lbl = etiquetas?.PagoEnLinea || {};

    return (
        <DialogoBoostrap
            open={abierto}
            onClose={() => setAbierto(false)}
            maxWidth="xs"
            fullWidth
        >
            <DialogContent style={{ textAlign: "center", padding: "24px" }}>
                <Box style={{ display: "inline-flex", marginBottom: 12 }}>
                    <CheckCircleOutlineIcon style={{ color: "#082375", fontSize: 48 }} />
                </Box>
                <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, color: "#082375" }}>
                    {lbl.Et_TituloPagoExitoso || "¡Tu pago fue un éxito!"}
                </Typography>
                <Typography style={{ fontSize: 14, color: "#3F425D", marginBottom: 16 }}>
                    {lbl.Et_DescripcionPagoExitoso ||
                        "Tu pago fue recibido exitosamente. La institución revisará tus requisitos y te notificará los próximos pasos por correo electrónico."}
                </Typography>
                <Box
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        backgroundColor: "#F3F7FB",
                        borderRadius: 8,
                        padding: "10px 12px",
                        marginBottom: 4,
                    }}
                >
                    <MarkEmailReadOutlinedIcon style={{ color: "#082375", fontSize: 20 }} />
                    <Typography style={{ fontSize: 12, color: "#3F425D", textAlign: "left" }}>
                        {lbl.Et_AvisoComprobante ||
                            "Revisa tu bandeja de entrada para encontrar el comprobante de pago."}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center", padding: "8px 24px 20px" }}>
                <Button
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "#082375", color: "#FFFFFF" }}
                    onClick={() => {
                        setAbierto(false);
                        onContinuar();
                    }}
                >
                    {lbl.Et_ContinuarAlInicio || "Continuar al inicio"}
                </Button>
            </DialogActions>
        </DialogoBoostrap>
    );
};

export const mostrarDialogoPagoExitoso = () => {
    funcionAbrirModal(!validaAbrirModal);
};
